import React, { Component } from 'react'

import { SimpleForm } from 'components/form'
import { TextInput, DatetimeInput } from 'components/input'
import { change as changeAction } from 'redux-form'
import { connect } from 'react-redux'

import { InputOptions } from 'util/constants'

import * as urls from './urls'
import * as utils from './utils'

import { Edit } from "components/detail";
import DisabledInput from "components/input/DisabledInput";

import { crudGetList as crudGetListAction } from 'actions/dataActions';


class ReminderConfigDropEditBase extends Component {
  handleSubmit = (props, basePath) => (record) => {
    const { formValues } = this.props;

    const last_support_day = new Date(formValues.dropping_version_last_support_day);
    last_support_day.setHours(23);
    last_support_day.setMinutes(59);
    last_support_day.setSeconds(59);

    const min_client_release_info = {
      app_type: formValues.app_type,
      client_type: formValues.client_type,
      version_number: utils.generateVersionNumber(formValues.dropping_version_number),
      last_support_day: parseInt(last_support_day.getTime() / 1000, 10),
    };
    const submitData = {
      min_client_versions: [
        min_client_release_info,
        {
          ...min_client_release_info,
          client_type: formValues.internal_client_type,
        }
      ],
    };
    props.crudUpdate(
      props.resource, 
      '', 
      submitData,
      {},
      props.editBackendPath,
      basePath
    );
  };

  render() {
    return (
      <Edit 
        {...this.props}
        title="Edit Dropping Version"
        editBackendPath={urls.reminderConfigMinDropEditBackendPath}
        basePath={urls.reminderConfigFrontendPath}
        showPath="drop/"
        hasShow={true}
        handleSubmit={this.handleSubmit}
      >
        <SimpleForm>
          <DisabledInput
            source='app_type'
            label='App type'
            choices={utils.APP_TYPE_LIST}
          />
          <DisabledInput
            source='client_type'
            label='Platform'
            choices={utils.CLIENT_TYPE_LIST}
          />
          <TextInput
            source='dropping_version_number'
            label='Version'
            isRequired={true}
            options={InputOptions}
          />
          <DatetimeInput
            source='dropping_version_last_support_day'
            label='Last Support Date'
            isRequired={true}
            options={InputOptions}
          />
        </SimpleForm>
      </Edit>
    );
  }
}

export const ReminderConfigDropEdit = connect(
  (state) => {
    return {
      submitFailed: (state.form['record-form'] || {}).submitFailed,
      syncErrors: ((state.form['record-form'] || {}).syncErrors || {}),
      formValues: ((state.form['record-form'] || {}).values || {}),
      formInitial: ((state.form['record-form'] || {}).initial || {}),
    }
  },
  {
    change: changeAction,
    customFetch: () => (
      crudGetListAction(
        utils.ReminderConfigResourceName, 
        urls.reminderConfigBackendPath,
        {}
      )
    ),
  }
)(ReminderConfigDropEditBase);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/ReminderConfigDropEdit.js